import React from 'react';

const BS_CSS_Tables = () => {
    return (
        <div>
            <h1>BS_CSS_Tables Component</h1>
            <p>Content coming soon...</p>
        </div>
    );
}

export default BS_CSS_Tables;
